module.exports = __webpack_public_path__ + "img/blog-img-1.d3b46469.jpg";